var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',{attrs:{"max-count":1,"before-read":_vm.asyncBeforeRead},on:{"delete":_vm.deleteImg},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}},[_c('img',{class:_vm.imgClassName,attrs:{"src":_vm.imgSrc,"mode":"aspectFit"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }